module.exports = __webpack_public_path__ + "static/media/box-alt.ca721778.svg";